import React, { useState, useEffect, useContext, useRef } from "react";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import { MyContext } from "./FormsView";
import { AdminMyContext } from "../../Pages/PreviewForm";
import { FormRowContext } from "./FormRowData";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import { FaInfoCircle } from "react-icons/fa";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import * as api from "../../api/api";
import { useMemoryFields } from "./MemoryFieldProvider";
function RenderField({ sectionField, data, isAdmin, isPreview }) {
  let contextToUse = isPreview ? AdminMyContext : MyContext;
  const {
    processDetails,
    setProcessDetails,
    parentSelectionValues,
    setParentSelectionValues,
  } = useContext(contextToUse);
  const { parentDisabled, parentStartServiceFromLink } =
    useContext(FormRowContext);
  const [fieldValue, setFieldValue] = useState("");
  const [customData, setCustomData] = useState({});
  const [serviceLinkData, setServiceLinkData] = useState({});
  const [parentSelectedValue, setParentSelectedValue] = useState("");
  const [multipleSelectedOptions, setMultipleSelectedOptions] = useState([]);
  const [isInvalidState, setIsInvalidState] = useState(false);
  const field = sectionField.field;
  const memoryFields = useMemoryFields();
  const memoryPrefillApplied = useRef(false);

  function getFieldValue() {
    // console.log("getting value");
    if (processDetails) {
      console.log("old process details: ", processDetails);
      // sort the process details by sectionFieldId
      processDetails.sort((a, b) => a.sectionFieldId - b.sectionFieldId);
      console.log("Sorted by processDetailId: ", processDetails);
      processDetails.forEach((field) => {
        if (field.sectionFieldId === sectionField.sectionFieldId) {
          if (sectionField.field.fieldType.description === "Multiselection") {
            //this means the field is of type multiselection and has its value stored as 1;2;3 for example
            console.log("field value is: ", field.value);
            let fieldValues = field.value ? field?.value?.split(";") : [];

            // setFieldValue(fieldValues);
            setMultipleSelectedOptions(fieldValues);
          } else if (sectionField.field.fieldType.description === "Boolean") {
            setFieldValue(field.value === true || field.value === "true");
          } else {
            console.log("field value is: ", field.value);
            setFieldValue(field.value);
          }
        }
      });
      console.log("new process details : ", processDetails);
    } else {
      setFieldValue("");
    }
  }
  function getParentValue(parentFieldId) {
    // console.log("getting value");
    let parentValue = "";
    if (processDetails) {
      console.log("old process details in getparent: ", processDetails);
      processDetails.forEach((field) => {
        console.log("searching in field ", field);
        console.log("for parentid ", parentFieldId);
        if (parentFieldId == field.fieldId) {
          console.log("found it here ", field);
          parentValue = field.value;
        }
      });

      return parentValue;
    } else {
      return parentValue;
    }
  }

  useEffect(() => {
    console.log("runningg");
    getFieldValue();
    try {
      let customData = JSON.parse(field.customData);
      setCustomData(customData);
      console.log("custom data is", customData);
    } catch (err) {
      console.log("can't parse custom data ", err);
    }
  }, [sectionField, processDetails]);

  // Memory Field: prefill from sessionStorage on initial mount
  useEffect(() => {
    if (
      memoryPrefillApplied.current ||
      !field.isMemoryField ||
      !memoryFields ||
      isPreview
    ) {
      return;
    }

    // Check if the field already has a value from processDetails (e.g. a saved/resumed process)
    const existingDetail = processDetails?.find(
      (d) =>
        d.sectionFieldId === sectionField.sectionFieldId &&
        d.value !== undefined &&
        d.value !== null &&
        d.value !== ""
    );
    if (existingDetail) {
      // Field already has data — write it to memory so subsequent forms inherit it
      memoryFields.setMemoryValue(field.fieldId, existingDetail.value);
      memoryPrefillApplied.current = true;
      return;
    }

    const memorizedValue = memoryFields.getMemoryValue(field.fieldId);
    if (memorizedValue === null || memorizedValue === undefined) {
      memoryPrefillApplied.current = true;
      return;
    }

    console.log(
      "MemoryField: prefilling",
      field.name,
      "with",
      memorizedValue
    );

    // Apply the memorized value to both local state and processDetails
    if (field.fieldType?.description === "Multiselection") {
      const options = memorizedValue ? String(memorizedValue).split(";") : [];
      setMultipleSelectedOptions(options);
    } else if (field.fieldType?.description === "Boolean") {
      const boolVal = memorizedValue === true || memorizedValue === "true";
      setFieldValue(boolVal);
    } else {
      setFieldValue(memorizedValue);
    }

    // Push into processDetails so the value gets saved with the process
    const valToPush =
      field.fieldType?.description === "Boolean"
        ? memorizedValue === true || memorizedValue === "true"
        : memorizedValue;

    setProcessDetails((prevDetails) => {
      const newDetails = [...prevDetails];
      const idx = newDetails.findIndex(
        (d) => d.sectionFieldId === sectionField.sectionFieldId
      );
      const entry = {
        sectionFieldId: sectionField.sectionFieldId,
        value: valToPush,
      };
      if (idx >= 0) {
        newDetails[idx] = entry;
      } else {
        newDetails.push(entry);
      }
      return newDetails;
    });

    // If this is a Selection field, also update parent selection tracking
    if (field.fieldType?.description === "Selection") {
      setParentSelectionValues((prev) => ({
        ...prev,
        [field.fieldId]: memorizedValue,
      }));
    }

    memoryPrefillApplied.current = true;
  }, [processDetails, sectionField]);

  useEffect(() => {
    //fetching the form for service link
    console.log("trying to fetch form for service");
    if (sectionField.field.fieldLayout?.name === "ServiceLink") {
      console.log("fetching form for service link ");
      try {
        let customData = JSON.parse(field.customData);
        api.getAgentFormById(customData.formId).then((response) => {
          // console.log("found form data:", response.data.object);
          setServiceLinkData({
            ...customData,
            formName: response?.data?.object?.name,
          });
        });
        console.log("custom data is", customData);
      } catch (err) {
        console.log("can't parse custom data ", err);
      }
    }
  }, []);

  useEffect(() => {
    // this part is concerned with Selection fields and populating the parent field
    if (field.fieldType.description === "Selection") {
      if (
        !field.parentFieldId &&
        !parentSelectionValues[sectionField.field.fieldId] &&
        customData.values
      ) {
        let value = customData.values ? customData.values.split(";")[0] : "";
        let fieldId = sectionField.field.fieldId;
        // updating context state with the parent value
        let newProcessDetails = [...processDetails];
        console.log("the context state update says: ", newProcessDetails);

        if (newProcessDetails.length > 0) {
          for (let i = 0; i < newProcessDetails.length; i++) {
            if (
              newProcessDetails[i].sectionFieldId == sectionField.sectionFieldId
            ) {
              console.log("found it already so i am breaking");
              setFieldValue(newProcessDetails[i].value);
              setParentSelectionValues((prevState) => ({
                ...prevState,
                [fieldId]: newProcessDetails[i].value,
              }));

              break;
            }
            if (i == newProcessDetails.length - 1) {
              newProcessDetails.push({
                sectionFieldId: sectionField.sectionFieldId,
                value: value,
              });
              console.log("pushing child field value", {
                sectionFieldId: sectionField.sectionFieldId,
                value: value,
              });
              console.log("the selection values i am trying to have", {
                ...parentSelectionValues,
                [fieldId]: value,
              });
              setParentSelectionValues((prevState) => ({
                ...prevState,
                [fieldId]: value,
              }));
              setFieldValue(value);
              break;
            }
          }
        } else {
          // null for when radiobuttonlist - horizontal or vertical
          // value: value is for all other cases
          if (
            sectionField.field.fieldLayout?.name ===
              "Radiobuttonlistvertical" ||
            sectionField.field.fieldLayout?.name === "Radiobuttonlisthorizontal"
          ) {
            value = null;
          }

          newProcessDetails.push({
            sectionFieldId: sectionField.sectionFieldId,
            value: value,
          });
          console.log(
            "pushing child field value",
            {
              sectionFieldId: sectionField.sectionFieldId,
              value: value,
            },
            customData.values
          );
          setParentSelectionValues((prevState) => ({
            ...prevState,
            [fieldId]: value,
          }));
          setFieldValue(value);
        }

        console.log("proc details in select", newProcessDetails);
        console.log(
          "parent selections in " + field.name + " ",
          parentSelectionValues
        );
        const mergeProcessDetails = (prevDetails, newDetails) => {
          // Create a map of existing entries for efficient lookup
          const existingDetailsMap = new Map(
            prevDetails.map((detail) => [detail.sectionFieldId, detail])
          );

          // Process each new detail
          newDetails.forEach((newDetail) => {
            // If this sectionFieldId already exists, update the map with the new value
            existingDetailsMap.set(newDetail.sectionFieldId, newDetail);
          });

          // Convert the map back to an array
          return Array.from(existingDetailsMap.values());
        };

        // Now use this function in your state update
        setProcessDetails((prevState) =>
          mergeProcessDetails(prevState, newProcessDetails)
        );
      }
    }
  }, [customData.values, parentSelectionValues[sectionField.field.fieldId]]);

  useEffect(() => {
    if (sectionField.field.parentFieldId) {
      console.log(" detected i am here: ", sectionField);

      // 1. Determine the parent's selected value (The Trigger)
      const parentValue =
        parentSelectionValues[sectionField.field.parentFieldId];
      setParentSelectedValue(parentValue);

      console.log(
        "detected parent value: ",
        parentValue,
        sectionField.field.name
      );

      // 2. Get the new potential values based on the parent
      const parentValues = customData?.parentValues
        ?.filter((v) => v.name && v.name === parentValue)[0]
        ?.values?.split(";");
      const childInitialValue = parentValues ? parentValues[0] : null;

      console.log(
        "detected child init value: ",
        childInitialValue,
        sectionField.field.name
      );

      // 3. Find the current entry for this specific child field
      const currentFieldData = processDetails.find(
        (f) => f.sectionFieldId === sectionField.sectionFieldId
      );

      let currentVal = currentFieldData?.value;
      
      // Fallback to memory field value if processDetails hasn't updated yet (to avoid race conditions on mount)
      if (
        (currentVal === undefined || currentVal === null || currentVal === "") &&
        field.isMemoryField &&
        memoryFields &&
        !isPreview
      ) {
        const memVal = memoryFields.getMemoryValue(field.fieldId);
        if (memVal !== null && memVal !== undefined) {
          currentVal =
            field.fieldType?.description === "Boolean"
              ? memVal === true || memVal === "true"
              : memVal;
        }
      }

      console.log("detected current field data value: ", currentFieldData, " resolved currentVal: ", currentVal);

      let valueToSet;

      if (parentDisabled) {
        // Logic for when the parent is disabled
        valueToSet = currentVal || childInitialValue;
      } else if (parentValues) {
        // Check if the existing value is still valid under the new parent selection
        if (field.fieldType?.description === "Multiselection" && currentVal) {
          const selectedOptions = currentVal.split(";");
          const validOptions = selectedOptions.filter((opt) => parentValues.includes(opt));
          valueToSet = validOptions.length > 0 ? validOptions.join(";") : childInitialValue;
        } else {
          valueToSet = parentValues.includes(currentVal)
            ? currentVal
            : childInitialValue;
        }
      } else {
        // No valid options for the current parent selection
        //valueToSet = null;
      }

      // 4. Update the shared state safely using the functional updater
      //    This is the critical fix for the race condition.
      setProcessDetails((prevDetails) => {
        let newDetails = [...prevDetails];
        let updated = false;

        for (let i = 0; i < newDetails.length; i++) {
          // Find and update the specific entry for THIS child
          if (newDetails[i].sectionFieldId === sectionField.sectionFieldId) {
            newDetails[i] = {
              ...newDetails[i],
              value: valueToSet,
            };
            updated = true;
            break;
          }
        }

        if (!updated) {
          // If not found, add the new field entry
          newDetails.push({
            sectionFieldId: sectionField.sectionFieldId,
            value: valueToSet,
          });
        }

        return newDetails;
      });

      // 5. Update local state and parent cache (if this child is also a parent)
      setFieldValue(valueToSet);
      if (field.fieldType?.description === "Multiselection") {
        setMultipleSelectedOptions(valueToSet ? String(valueToSet).split(";") : []);
      }
      setParentSelectionValues((prevState) => ({
        ...prevState,
        [sectionField.field.fieldId]: valueToSet,
      }));
    }
    console.table("latest selection vals: ", parentSelectionValues);
  }, [parentSelectionValues[sectionField.field.parentFieldId]]);

  // useEffect(() => {
  //   console.log(parentSelectedValue)

  // }, [parentSelectedValue]);
  function handleFormChanges(e) {
    let value = e.target.value;
    if (
      (field.fieldType.description === "Text" ||
        field.fieldType.description === "Number/Counter" ||
        field.fieldType.description === "Number / Counter") &&
      field.validationRegEx
    ) {
      let reg = new RegExp(field.validationRegEx);
      setIsInvalidState(!reg.test(value));
    }
    const { checked, name } = e.target;
    let newOptions = multipleSelectedOptions;
    if (e.target.type === "checkbox") {
      if (sectionField.field.fieldType.description === "Multiselection") {
        if (checked) {
          newOptions = [...multipleSelectedOptions, name];
        } else {
          newOptions = multipleSelectedOptions.filter(
            (option) => option !== name
          );
        }
        setMultipleSelectedOptions(newOptions);
        console.log("new Options are:", newOptions);
      } else {
        value = e.target.checked;
      }
    }
    if (
      sectionField.field?.fieldLayout?.name === "Radiobuttonlistvertical" ||
      sectionField.field?.fieldLayout?.name === "Radiobuttonlisthorizontal"
    ) {
      // here, sometimes it's value and sometimes it's name (when for a child)
      setFieldValue(value);
    }
    console.log("value is : ", value);

    if (field.fieldType.description === "Selection") {
      let fieldId = sectionField.field.fieldId;
      // updating context state with the parent value
      console.log(
        "selec values bef changing parent:" + field.name + "",
        parentSelectionValues
      );
      setParentSelectionValues((prevState) => ({
        ...prevState,
        [fieldId]: value,
      }));
    }

    if (
      false &&
      isAdmin &&
      sectionField.field.fieldType.description !== "Multiselection"
    ) {
      setFieldValue(value);
    } else {
      let newProcessDetails = [...processDetails];
      if (newProcessDetails.length > 0) {
        for (let i = 0; i < newProcessDetails.length; i++) {
          let fieldData = newProcessDetails[i];
          if (fieldData.sectionFieldId === sectionField.sectionFieldId) {
            newProcessDetails[i] = {
              sectionFieldId: sectionField.sectionFieldId,
              value:
                sectionField.field.fieldType.description !== "Multiselection"
                  ? value
                  : newOptions.join(";"),
            };
            break;
          }
          if (i === newProcessDetails.length - 1) {
            newProcessDetails.push({
              sectionFieldId: sectionField.sectionFieldId,
              value:
                sectionField.field.fieldType.description !== "Multiselection"
                  ? value
                  : newOptions.join(";"),
            });
            break;
          }
        }
      } else {
        newProcessDetails.push({
          sectionFieldId: sectionField.sectionFieldId,
          value:
            sectionField.field.fieldType.description !== "Multiselection"
              ? value
              : newOptions.join(";"),
        });
      }

      setProcessDetails(newProcessDetails);
      setFieldValue(value);
    }

    // Memory Field: persist the new value to sessionStorage
    if (field.isMemoryField && memoryFields && !isPreview) {
      const valueToStore =
        sectionField.field.fieldType.description === "Multiselection"
          ? newOptions.join(";")
          : sectionField.field.fieldType.description === "Boolean"
          ? Boolean(value)
          : String(value);
      memoryFields.setMemoryValue(field.fieldId, valueToStore);
    }
  }

  function handleMultipleDropdownChange(selectedOptions) {
    setMultipleSelectedOptions(selectedOptions);
    let newProcessDetails = [...processDetails];
    if (newProcessDetails.length > 0) {
      for (let i = 0; i < newProcessDetails.length; i++) {
        let fieldData = newProcessDetails[i];
        if (fieldData.sectionFieldId === sectionField.sectionFieldId) {
          newProcessDetails[i] = {
            sectionFieldId: sectionField.sectionFieldId,
            value: selectedOptions.join(";"),
          };
          break;
        }
        if (i === newProcessDetails.length - 1) {
          newProcessDetails.push({
            sectionFieldId: sectionField.sectionFieldId,
            value: selectedOptions.join(";"),
          });
          break;
        }
      }
    } else {
      newProcessDetails.push({
        sectionFieldId: sectionField.sectionFieldId,
        value: selectedOptions.join(";"),
      });
    }

    setProcessDetails(newProcessDetails);

    // Memory Field: persist the new multiselection value to sessionStorage
    if (field.isMemoryField && memoryFields && !isPreview) {
      memoryFields.setMemoryValue(field.fieldId, selectedOptions.join(";"));
    }
  }

  switch (field.fieldType.description) {
    case "Boolean":
      //   return <>{data ? "True" : "False"}</>;
      return (
        <div className="process-details-grid">
          <h6
            style={{ color: "var(--accent-color)" }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div
            className="grid-item"
            style={{ width: "100%", marginLeft: "1em" }}
          >
            <Form.Group>
              <Form.Check
                required={field.isRequired ? true : false}
                // type={type}
                // id={`default-${type}`}
                style={{
                  width: "1.5em !important",
                  height: "1.5em !important",
                }}
                checked={fieldValue === true || fieldValue === "true"}
                onChange={(e) => handleFormChanges(e)}
                disabled={parentDisabled}
                key={field.fieldId}

                //   label={"Show inactive"}
              />
              <Form.Control.Feedback type="invalid">
                value is required!
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        </div>
      );
    case "Date / DateTime":
      return (
        <div className="process-details-grid">
          <h6
            style={{ color: "var(--accent-color)" }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div className="grid-item" style={{ width: "100%" }}>
            {field?.fieldLayout?.name === "Date" ? (
              <Form.Group>
                <Form.Control
                  required={field.isRequired ? true : false}
                  type="date"
                  id="inputDate2"
                  value={fieldValue ? fieldValue.substring(0, 10) : ""}
                  name="date"
                  onChange={(e) => handleFormChanges(e)}
                  disabled={parentDisabled}
                  max="9999-12-31"
                />
                <Form.Control.Feedback type="invalid">
                  value is required!
                </Form.Control.Feedback>
              </Form.Group>
            ) : (
              <Form.Group>
                <Form.Control
                  // pattern={field.validationRegEx}
                  required={field.isRequired ? true : false}
                  type="datetime-local"
                  id="inputDate3"
                  value={fieldValue ? fieldValue : ""}
                  name="datetime"
                  onChange={(e) => handleFormChanges(e)}
                  disabled={parentDisabled}
                  max="9999-12-31T23:59:00"
                />
                <Form.Control.Feedback type="invalid">
                  value is required!
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </div>
        </div>
      );
    case "Multiselection":
      return (
        <div className="process-details-grid">
          <h6
            style={{
              color: "var(--accent-color)",
              maxWidth: "100px",
              wordWrap: "break-word",
            }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div className="grid-item" style={{ width: "100%" }}>
            {field?.fieldLayout?.name === "Checkboxesvertical" ? (
              customData?.values &&
              customData?.values?.split(";").map((value) => {
                return (
                  <Form.Group key={field.fieldId + "" + value}>
                    <Form.Check // prettier-ignore
                      required={field.isRequired && multipleSelectedOptions.length === 0 ? true : false}
                      type={"checkbox"}
                      // id={`default-${type}`}
                      label={value}
                      name={value}
                      disabled={parentDisabled}
                      checked={multipleSelectedOptions.includes(value)}
                      onChange={(e) => handleFormChanges(e)}
                    />
                    <Form.Control.Feedback type="invalid">
                      value is required!
                    </Form.Control.Feedback>
                  </Form.Group>
                );
              })
            ) : (
              // <Stack spacing={3} sx={{ minWidth: "30em" }}>
              <div
                style={{
                  backgroundColor: parentDisabled ? "#e9ecef" : "white",
                }}
              >
                {/* <Stack spacing={3}  sx={{ maxHeight: "3em" }}> */}
                <Autocomplete
                  multiple
                  // isOptionEqualToValue={(option, value) =>
                  //   option.teamId === value.teamId
                  // }
                  size="sm"
                  disabled={parentDisabled}
                  id="tags-outlined"
                  options={
                    customData.values ? customData.values.split(";") : []
                  }
                  // getOptionLabel={(option) => option.name}
                  // defaultValue= {teams ? teams : []}
                  value={multipleSelectedOptions ? multipleSelectedOptions : []}
                  onChange={(event, newValue) => {
                    handleMultipleDropdownChange(newValue);
                  }}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      // label="Assigned Teams"
                      // placeholder="Assigned teams"
                    />
                  )}
                />
                {/* </Stack> */}
              </div>
            )}
          </div>
        </div>
      );
    case "Number/Counter":
      return (
        <div className="process-details-grid">
          <h6
            style={{ color: "var(--accent-color)" }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div className="grid-item" style={{ width: "100%" }}>
            <Form.Group>
              <Form.Control
                isInvalid={isInvalidState}
                pattern={field.validationRegEx ? field.validationRegEx : ".*"}
                required={field.isRequired ? true : false}
                name="counter"
                type="number"
                value={fieldValue}
                disabled={parentDisabled}
                onChange={(e) => handleFormChanges(e)}
              />
              <Form.Control.Feedback type="invalid">
                {field.validationRegEx
                  ? fieldValue
                    ? "Does not match pattern"
                    : "value is required!"
                  : !fieldValue
                  ? "value is required!"
                  : ""}
              </Form.Control.Feedback>
            </Form.Group>
          </div>
        </div>
      );
    case "Selection":
      return (
        <div className="process-details-grid">
          <h6
            style={{ color: "var(--accent-color)" }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div className="grid-item" style={{ width: "100%" }}>
            {!sectionField.field.parentFieldId ? (
              field?.fieldLayout?.name === "Multiselectdropdownlist" ||
              field?.fieldLayout?.name === "Dropdownlist" ? (
                <Form.Group key={sectionField.sectionFieldId}>
                  <Form.Select
                    required={field.isRequired ? true : false}
                    value={fieldValue}
                    disabled={parentDisabled}
                    onChange={(e) => handleFormChanges(e)}
                    key={field.fieldId}
                  >
                    {customData?.values?.split(";").map((option) => {
                      return (
                        <option
                          key={field.fieldId + "" + option}
                          value={option}
                        >
                          {option}
                        </option>
                      );
                    })}
                  </Form.Select>
                  <Form.Control.Feedback type="invalid">
                    value is required!
                  </Form.Control.Feedback>
                </Form.Group>
              ) : (
                <Form.Group key={field.fieldId}>
                  {customData?.values?.split(";").map((option) => {
                    return (
                      <Form.Check
                        pattern={field.validationRegEx}
                        onChange={(e) => {
                          handleFormChanges(e);
                          console.log("option is: ", option);
                        }}
                        key={
                          field.fieldId +
                          "" +
                          sectionField.sectionFieldId +
                          option +
                          field.name
                        }
                        inline={
                          field?.fieldLayout?.name ===
                          "Radiobuttonlisthorizontal"
                        }
                        label={option}
                        name={`field-${field.fieldId}-${sectionField.sectionFieldId}`} // shared name for all options in one group
                        type={"radio"}
                        checked={fieldValue?.trim() === option?.trim()}
                        id={
                          field.fieldId +
                          "" +
                          sectionField.sectionFieldId +
                          option +
                          field.name
                        }
                        value={option}
                        disabled={parentDisabled}
                        required={field.isRequired ? true : false}
                      />
                    );
                  })}
                  <Form.Control.Feedback type="invalid">
                    value is required!
                  </Form.Control.Feedback>
                </Form.Group>
              )
            ) : field?.fieldLayout?.name === "Multiselectdropdownlist" ||
              field?.fieldLayout?.name === "Dropdownlist" ? (
              <Form.Group key={field.fieldId}>
                <Form.Select
                  required={field.isRequired ? true : false}
                  value={fieldValue}
                  disabled={parentDisabled}
                  onChange={(e) => handleFormChanges(e)}
                >
                  {customData?.parentValues
                    ?.filter(
                      (v) =>
                        v.name === parentSelectedValue && v.name !== undefined
                    )[0]
                    ?.values?.split(";")
                    .map((option) => {
                      return (
                        <option
                          key={field.fieldId + "" + option}
                          value={option}
                        >
                          {option}
                        </option>
                      );
                    })}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  value is required!
                </Form.Control.Feedback>
              </Form.Group>
            ) : (
              <>
                <Form.Group key={`${field.fieldId}-${parentSelectedValue}`}>
                  {customData?.parentValues
                    ?.filter((v) => v.name && v.name === parentSelectedValue)[0]
                    ?.values?.split(";")
                    .map((option) => {
                      return (
                        <Form.Check
                          key={
                            field.fieldId +
                            "" +
                            sectionField.sectionFieldId +
                            option +
                            field.name
                          }
                          onChange={(e) => {
                            handleFormChanges(e);
                            console.log("option is: ", option);
                          }}
                          inline={
                            field?.fieldLayout?.name ===
                            "Radiobuttonlisthorizontal"
                          }
                          label={option}
                          name={`field-${field.fieldId}-${sectionField.sectionFieldId}`} // shared name for all options in one group
                          type={"radio"}
                          checked={fieldValue?.trim() === option?.trim()}
                          required={field.isRequired ? true : false}
                          id={
                            field.fieldId +
                            "" +
                            sectionField.sectionFieldId +
                            option +
                            field.name
                          }
                          value={option}
                          disabled={parentDisabled}
                        />
                      );
                    })}
                </Form.Group>
              </>
            )}
          </div>
        </div>
      );
    case "Service Link":
      return (
        <div className="process-details-grid">
          <h6
            style={{ color: "var(--accent-color)" }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div className="grid-item" style={{ width: "100%" }}>
            {serviceLinkData?.formName && (
              <p
                className="service-link"
                onClick={() => {
                  if (!parentDisabled) {
                    parentStartServiceFromLink(
                      serviceLinkData.serviceId,
                      serviceLinkData.formId
                    );
                  }
                }}
              >
                {serviceLinkData.formName}
              </p>
            )}
          </div>
        </div>
      );
    case "Text":
      return (
        <div className="process-details-grid">
          <h6
            style={{ color: "var(--accent-color)" }}
            className={field.isRequired ? "required-field" : ""}
          >
            {field.name}
            {field.helpText && (
              <Tooltip title={field.helpText} arrow>
                <IconButton>
                  <FaInfoCircle
                    style={{
                      color: "var(--accent-color)",
                      width: "0.7em",
                      height: "0.7em",
                    }}
                  ></FaInfoCircle>
                </IconButton>
              </Tooltip>
            )}
          </h6>
          <div className="grid-item" style={{ width: "100%" }}>
            {field?.fieldLayout?.name === "Singleline" ? (
              <Form.Group>
                <Form.Control
                  // isInvalid = {field.validationRegEx ? !(new RegExp(field.validationRegEx).test(fieldValue)) : false}
                  isInvalid={isInvalidState}
                  pattern={field.validationRegEx ? field.validationRegEx : ".*"}
                  required={field.isRequired ? true : false}
                  name="name"
                  type="text"
                  value={fieldValue}
                  disabled={parentDisabled}
                  onChange={(e) => handleFormChanges(e)}
                />
                <Form.Control.Feedback type="invalid">
                  {field.validationRegEx
                    ? fieldValue
                      ? "Does not match pattern"
                      : "value is required!"
                    : !fieldValue
                    ? "value is required!"
                    : ""}
                </Form.Control.Feedback>
              </Form.Group>
            ) : (
              <Form.Group>
                <Form.Control
                  isInvalid={isInvalidState}
                  pattern={field.validationRegEx ? field.validationRegEx : ".*"}
                  required={field.isRequired ? true : false}
                  name="name"
                  as="textarea"
                  rows={3}
                  value={fieldValue}
                  disabled={parentDisabled}
                  onChange={(e) => handleFormChanges(e)}
                />
                <Form.Control.Feedback type="invalid">
                  {field.validationRegEx
                    ? fieldValue
                      ? "Does not match pattern"
                      : "value is required!"
                    : !fieldValue
                    ? "value is required!"
                    : ""}
                </Form.Control.Feedback>
              </Form.Group>
            )}
          </div>
        </div>
      );

    default:
      return <></>;
  }
}

export default RenderField;
